export default "__VITE_ASSET__DEZ09VSy__"